<template>
  <VContainer class="latest-comments-page">
    <VRow v-if="isLoading">
      <VCol cols="12">
        <div class="d-flex flex-column align-center justify-center py-4 w-100">
          <VProgressCircular indeterminate color="primary" />
        </div>
      </VCol>
    </VRow>
    <VRow v-else>
      <VCol cols="12">
        <Card class="w-100">
          <div class="comments">
            <template v-if="comments.length">
              <div
                class="comments__item"
                v-for="comment in comments"
                :key="comment.subject"
                @click="handleViewComment(comment)"
              >
                <div class="d-flex gap-16">
                  <VIcon icon="mdi-email-outline" size="large"></VIcon>
                  <div class="comments__item__title">{{ comment.subject }}</div>
                </div>

                <div class="comments__item__date">{{ comment.createdDate }}</div>
              </div>
            </template>
            <div v-else class="d-flex gap-10 my-3">
              <VIcon icon="mdi-information-slab-circle-outline" size="24" color="primary"></VIcon>
              <span>Latest Comments not found!</span>
            </div>
          </div>
        </Card>
      </VCol>
    </VRow>
  </VContainer>
  <ViewCommentModal v-model="isShowViewCommentModal" :commentId="commentId" />
</template>
<script>
import { mapActions } from 'vuex';
// Components
import Card from '@/components/common/Card/Card.vue';
import ViewCommentModal from '@/components/modals/ViewCommentModal/ViewCommentModal.vue';
// Service
import applicationService from '@/services/application-service/application.service';
// Utils
import { formatLatestComments } from '@/utils/formatData';
export default {
  name: 'LatestCommentsPage',
  components: {
    Card,
    ViewCommentModal
  },
  data() {
    return {
      isLoading: true,
      comments: [],
      isShowViewCommentModal: false,
      commentId: null
    };
  },
  mounted() {
    this.getLatestComments();
  },
  methods: {
    ...mapActions('main', ['showSnackbar']),
    async getLatestComments() {
      this.isLoading = true;
      try {
        const { comments } = await applicationService.getLatestComments({});
        this.comments = formatLatestComments(comments ?? []);
      } catch (err) {
        console.error(err);
        this.showSnackbar({ text: err?.message || 'Oops, Something Went Wrong', color: 'red' });
      } finally {
        this.isLoading = false;
      }
    },
    // View Comment
    handleViewComment(item) {
      if (!item?.commentId) {
        return;
      }
      this.isShowViewCommentModal = true;
      this.commentId = item.commentId;
    }
  }
};
</script>
